var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTime = function SvgTime(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M548 38.8h-2.7c-26.6 0-45.4 21.2-45.4 48s10.7 48 50.7 48c189.3 2.7 356.1 165.4 356.1 363.9 0 201.3-165.4 366.6-365.4 366.6-192 0-350.7-143.9-365.4-334.6H260L130.7 313.4 0 530.7h80c14.6 240 214.6 430.5 460 430.5 253.4 0 460-207.9 460-461.2 0-250.7-201.2-456.1-452-461.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M590.7 262.7c0-22.7-18.8-42.7-41.2-42.7h-9.3c-22.7 0-40 20-40 42.7v242.7L381.4 624.1c-17.3 17.3-16.1 45.4 0 62.7s45.4 17.3 62.7 0l130.7-130.7c1.2-1.2 1.2-2.7 2.7-2.7 6.6-8 12-17.3 12-29.3V262.7z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTime);
export default ForwardRef;